/* eslint-disable complexity */
// NOSONAR
import ApplicationDetailsReview from '@/components/config_components/ApplicationDetailsReview/ApplicationDetailsReview.vue';
import HistoricalVerificationChecksView from '@/components/config_components/HistoricalVerificationChecksView/HistoricalVerificationChecksView.vue';
import ManualVerificationHistoryView from '@/components/config_components/ManualVerificationHistoryView/ManualVerificationHistoryView.vue';
import FacialVerificationField from '@/views/onboarding_system_views/Applicant/IntakePortal/FacialVerificationField.vue';
import { queueFormHistoryComputed } from './queue_form_history_helpers';
import { queueFormMethods } from './queue_form_methods';
import { queueFormPageComputed } from './queue_form_page_computed';

export default {
  name: 'OnboardingQueueForm',
  components: {
    ApplicationDetailsReview,
    FacialVerificationField,
    HistoricalVerificationChecksView,
    ManualVerificationHistoryView
  },
  data: () => ({
    is_loading_form_page: false,
    form_page_error: '',
    is_submitting: false,
    submit_success_message: '',
    allowed_actions: [],
    application_forms: [],
    selected_application_form_id: '',
    selected_application_form_meta: null,
    selected_application_form_detail: null,
    intake_steps: [],
    current_step: 1,
    workflow_stage_timeline: [],
    configured_gate_ids: [],
    workflow_transition_history: [],
    hydrated_case_detail: null,
    active_history_gate_id: '',
    active_history_tab: 'summary',
    history_panel_loading: false,
    history_panel_error: '',
    history_manual_run: null,
    history_verification_checks: [],
    expanded_history_verification_keys: [],
    form_values: {},
    file_values: {},
    file_previews: {},
    persisted_file_urls: {},
    facial_verification_values: {},
    queue_form_load_token: 0,
    preview_modal_visible: false,
    preview_modal_title: '',
    preview_modal_url: '',
    preview_modal_type: '',
    history_document_review_comments: {},
    history_document_review_in_progress_by_id: {},
    history_document_review_feedback: '',
    history_document_review_feedback_tone: 'success'
  }),
  watch: {
    '$route.fullPath': {
      async handler() {
        this.close_preview_modal();
        this.reset_queue_form_state();
        await this.load_application_forms();
      }
    },
    current_step() {
      this.$nextTick(() => this.scroll_active_step_into_view());
    },
    intake_steps() {
      this.$nextTick(() => this.scroll_active_step_into_view());
    }
  },
  computed: {
    ...queueFormPageComputed,
    ...queueFormHistoryComputed
  },
  async mounted() {
    await this.load_application_forms();
  },
  updated() {
    if (this.is_loading_form_page) {
      this.show_queue_form_loader();
    }
  },
  beforeUnmount() {
    Object.values(this.file_previews).forEach((preview_url) => {
      if (preview_url) URL.revokeObjectURL(preview_url);
    });
    window.dispatchEvent(new CustomEvent('onboarding-case-scope-cleared'));
  },
  methods: queueFormMethods
};
